import React from 'react'
import EstimationActions from '../../libs/EstimationActions'
import ConditionList from '../../libs/ConditionList'
import { withRouter } from 'react-router'

import Description from './abstract/Description'
import Window from '../../../common/Window'

// 最大階層数
const MAX_CONDITIONS = 10
// 自由入力の選択肢のID
const FREE_INPUT_VALUE = 9

class DescriptionMitsumori extends Description {
  constructor (props) {
    super(props)
    this.state = {
      data: EstimationActions.getCurrentEstimation()
    }
  }
  render () {
    const { data } = this.state
    const conditionNames = []
    for (let i = 0; i < MAX_CONDITIONS; i++) {
      const id = Number(data[`estimationConditions${i}`])

      // null / undefined / '' / 0 は除外
      if (!id) continue  

      if (id === FREE_INPUT_VALUE) {
        // ID が 9 のとき自由入力を取得
        const freeText = data[`estimationConditionsFree${i}`]
        if (freeText && freeText.trim() !== '') {
          conditionNames.push(freeText)
        }
      } else {
        // 通常の選択肢
        const conditionObj = ConditionList.find(item => item.id === id)
        if (conditionObj) {
          conditionNames.push(conditionObj.name)
        }
      }
    }
    return (
        <div className='kw-description-mitsumori'>
          <table>
            <tbody>
            {conditionNames.map((name, index) => (
              <tr key={index}>
                <td className='text-left' style={{ padding: '7px 10px', fontSize: '120%' }}>・{name}</td>
              </tr>
            ))}
            </tbody>
          </table>
        </div>
    )
  }
}
export default withRouter(DescriptionMitsumori)



// WEBPACK FOOTER //
// ./src/company_user/print/LaborUnitPriceTab/DescriptionMitsumori.js